import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Header from "@/components/layout/Header";
import CommandPalette from "@/components/layout/CommandPalette";
import { useAuth } from "@/lib/auth";

export default function AppLayout() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [cmdkOpen, setCmdkOpen] = useState(false);

    useEffect(() => {
        if (!loading && !user) {
            navigate("/login", { replace: true, state: { from: location.pathname } });
        }
    }, [loading, user, navigate, location]);

    if (loading || !user) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-brand-void">
                <div className="w-8 h-8 rounded-full border-2 border-white/10 border-t-brand-indigo animate-spin" />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-brand-void text-white">
            <Sidebar />
            <div className="pl-[248px] transition-[padding] duration-300">
                <Header onOpenCmdk={() => setCmdkOpen(true)} />
                <main className="min-h-[calc(100vh-64px)]">
                    <Outlet />
                </main>
            </div>
            <CommandPalette open={cmdkOpen} onOpenChange={setCmdkOpen} />
        </div>
    );
}
